module.exports = __webpack_public_path__ + "img/btn-sign-in-with-google.b0dec14a.png";